import React, { useEffect, useState } from "react";
import Scrollbar from "../../../scrollbar";
import { useAppSelector } from "../../../../utils/redux/hooks";
import { RootState } from "../../../../utils/redux/store";
import EmptyState from "../../emptyState";
import { FiFilter } from "react-icons/fi";
import { formatDate } from "../tempFour";
import { exportToCsv } from "../TempTwoTabs/allOrders";
import { useNavigate, useParams } from "react-router";
import GoBack from "../../../GoBack";

const items = ["All Payment", "Failed", "Accepted", "Pending", "Refund"];

const Funding = ({ viewWallet }: any) => {
  const [selectedTab, setSelectedTab] = useState(items[0]);

  const [currentPage, setCurrentPage] = useState(1);

  const userTransactions = useAppSelector(
    (store: RootState) => store.user.userTransactions
  );
  const itemsToDisplay = userTransactions?.filter(
    (item: { type: string }) => item?.type === "funding"
  );

  const itemsPerPage = 15;
  const totalItems = itemsToDisplay?.length;
  const allItems = itemsToDisplay;
  console.log("VEIWEWALLLET -------", viewWallet);
  function sumAmounts(transactions: any[]) {
    let totalAmount = 0;

    for (let transaction of transactions) {
      if (transaction.amount) {
        totalAmount += transaction.amount;
      }
    }

    return totalAmount;
  }

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
  const itemsToShow = allItems?.slice(startIndex, endIndex);

  const handlePrevPageClick = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPageClick = () => {
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const [isFilterClicked, setIsFilterClicked] = useState(false);
  const [filterRef, setFilterRef] = useState<null | any>(null);
  useEffect(() => {
    setFilterRef(document.getElementById("filter-container"));
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (filterRef && !filterRef.contains(event.target)) {
        setIsFilterClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [filterRef]);

  const toggleFilter = () => {
    setIsFilterClicked((prev) => !prev);
  };

  const headers = [
    "Payment ID",
    "Date",
    "Amount",
    "First Name",
    "Last Name",
    "Business Name",
    "Payment Gateway",
    "Status",
  ];

  const keys = [
    "_id",
    "createdAt",
    "amount",
    "firstName",
    "lastName",
    "businessName",
    "paymentGw",
    "status",
  ];

  const handleExportToCsv = () => {
    exportToCsv({
      data: itemsToDisplay,
      headers,
      keys,
      fileName: "pureworkerWallet.csv",
    });
  };

  const username =
    viewWallet?.businessName ||
    `${viewWallet?.firstName} ${viewWallet?.lastName}`;

  const navigate = useNavigate();
  const query = useParams();

  return (
    <div>
      <div>
        {/* <div className="flex border-b-[0.1rem] border-[#000] gap-12 mt-4 mb-6 w-full lg:w-fit pr-12 overflow-x-auto ">
          {items.map((item, index) => (
            <p
              key={index}
              className={`font-roboto text-base font-medium leading-normal cursor-pointer whitespace-nowrap ${
                index === selectedTab ? "border-b-2 border-[#88087B]" : ""
              }`}
              onClick={() => setSelectedTab(index)}
            >
              {" "}
              {item}{" "}
              <span className="bg-[#88087B]  text-[#fff] text-sm px-1 rounded-sm">
                {item === "All Payment"
                  ? itemsToDisplay?.length
                  : item === "Failed"
                  ? userTransactions?.filter(
                      (item) => item?.status === "failed"
                    )?.length
                  : 0}
              </span>
            </p>
          ))}
        </div> */}
        <div className="hidden lg:flex flex-col lg:flex-row justify-between gap-4 items-center">
          <div className="flex gap-4 text-[#88087B] items-center">
            <GoBack />
            <p className="font-roboto text-2xl lg:text-3xl font-medium leading-normal">
              {username}
            </p>
            <p className="border-l-2 border-[#000] px-2 font-roboto text-base sm:text-lg font-medium leading-normal">
              Rating: {parseFloat(viewWallet?.averageRating.toFixed(2)) || 0}
            </p>
            <p className="border border-[#000] px-1 font-roboto text-base sm:text-lg font-medium leading-normal">
              Wallet Balance: ₦{" "}
              {viewWallet?.wallet?.availableBalance.toLocaleString()}
            </p>
          </div>

          <div className=" relative" id="filter-container">
            <FiFilter
              size={20}
              className="text-[#88087B] cursor-pointer"
              onClick={toggleFilter}
            />
            {isFilterClicked && (
              // <div className="flex lg:flex-wrap border-b-[0.1rem] border-[#000] gap-4 lg:gap-0 lg:justify-between overflow-x-auto lg:overflow-hidden mt-3">
              <div className="absolute top-5 right-0 space-y-2 border w-max p-6 bg-white rounded-sm">
                {items.map((item, index) => (
                  <p
                    key={index}
                    className={`flex py-1 justify-between gap-3 hover:border-b-2 hover:border-[#88087B] font-roboto lg:text-base text-sm font-medium leading-normal cursor-pointer whitespace-nowrap ${
                      item === selectedTab
                        ? "border-b-2 border-[#88087B]"
                        : // ""
                          ""
                    }`}
                    onClick={() => {
                      setSelectedTab(item);
                      toggleFilter();
                    }}
                  >
                    <span>{item} </span>
                    <span className="bg-[#88087B]  text-[#fff] text-sm px-1 rounded-sm">
                      {item === "All Payment"
                        ? itemsToDisplay?.length
                        : item === "Failed"
                        ? userTransactions?.filter(
                            (item) => item?.status === "failed"
                          )?.length
                        : 0}
                    </span>
                  </p>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="flex lg:hidden flex-col text-[#88087B] w-full  justify-between gap-4 items-center">
          <div className="flex justify-between w-full items-center">
            <p className="font-roboto text-3xl lg:text-3xl font-medium leading-normal">
              {viewWallet?.firstName} {viewWallet?.lastName}
            </p>
            <p className="border-x-2 px-4 border-[#000]  font-roboto text-base sm:text-lg font-medium leading-normal">
              Rating: 4.8
            </p>

            {/* for mobie  */}

            <div className=" relative" id="filter-container">
              <FiFilter
                size={20}
                className="text-[#88087B] cursor-pointer"
                onClick={toggleFilter}
              />
              {isFilterClicked && (
                // <div className="flex lg:flex-wrap border-b-[0.1rem] border-[#000] gap-4 lg:gap-0 lg:justify-between overflow-x-auto lg:overflow-hidden mt-3">
                <div className="absolute top-5 right-0 space-y-2 border w-max p-6 bg-white rounded-sm">
                  {items.map((item, index) => (
                    <p
                      key={index}
                      className={`flex py-1 justify-between gap-3 hover:border-b-2 hover:border-[#88087B] font-roboto lg:text-base text-sm font-medium leading-normal cursor-pointer whitespace-nowrap ${
                        item === selectedTab
                          ? "border-b-2 border-[#88087B]"
                          : // ""
                            ""
                      }`}
                      onClick={() => {
                        setSelectedTab(item);
                        toggleFilter();
                      }}
                    >
                      <span>{item} </span>
                      <span className="bg-[#88087B]  text-[#fff] text-sm px-1 rounded-sm">
                        {item === "All Payment"
                          ? itemsToDisplay?.length
                          : item === "Failed"
                          ? userTransactions?.filter(
                              (item) => item?.status === "failed"
                            )?.length
                          : 0}
                      </span>
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>

          <p
            onClick={() => {
              // navigate(`/provider5`);
            }}
            className="border border-[#000] px-2 font-roboto text-base sm:text-xl font-medium leading-normal"
          >
            Wallet Balance: ₦{" "}
            {viewWallet?.wallet?.availableBalance.toLocaleString()}
          </p>
        </div>
        <div className="my-4">
          <button
            className="px-4 py-2 rounded-md bg-[#88087B] text-white font-semibold disabled:bg-gray-600"
            onClick={() => {
              navigate(`alterWallet`);
            }}
          >
            Alter Balance
          </button>
        </div>
        {items.map((item, index) => (
          <div
            key={index}
            style={{
              display: item === selectedTab ? "block" : "none",
            }}
          >
            {index === 0 && (
              <div>
                {itemsToDisplay?.length > 0 && (
                  <section className="mt-2">
                    <div className="overflow-hidden rounded-t-lg">
                      <table className="w-full">
                        <thead className="bg-[#fff] text-[#49454FCC] font-roboto text-sm lg:text-base font-medium text-center whitespace-nowrap">
                          <tr>
                            <th className="py-3">Payment ID</th>
                            <th className="py-3">Date</th>
                            <th className="py-3">Amount</th>
                            <th className="py-3">Payment Channel</th>
                            <th className="py-3">Payment Gateway</th>
                            <th className="py-3">Status</th>
                            <th className="py-3">Type</th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemsToShow.map((item) => (
                            <tr
                              // onClick={() => {
                              //   navigate(`/wallet/${item.id}`);
                              // }}
                              key={item.id}
                              className="hover:bg-[#ededf3] mt-2 transition duration-300 font-roboto text-xs font-medium leading-normal  text-center text-[#222222E5]"
                            >
                              <td className="py-4 ">{item?._id}</td>
                              <td className="py-4  ">
                                {formatDate(item?.createdAt)}
                              </td>

                              <td className="py-4 ">
                                {item?.amount.toLocaleString()}
                              </td>
                              <td className="py-4 capitalize">
                                {item?.channel}
                              </td>
                              <td className="py-4 capitalize">
                                {item?.gateway || ""}
                              </td>
                              <td className="py-4 capitalize">
                                {item?.status || "status"}
                              </td>
                              <td className={`py-4 `}>
                                <div
                                  className={`capitalize text-white  ${
                                    item?.type === "funding"
                                      ? "bg-[#2D4A92]"
                                      : item?.type === "reversal"
                                      ? "bg-green-700"
                                      : "bg-[#88087B]"
                                  } rounded-lg`}
                                >
                                  {item?.type || "type"}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="flex justify-end px-4 mt-8 -mb-8 gap-4">
                      <p className="bg-[#000] text-[#FFCD1E] px-4 rounded-md text-center text-shadow-md font-roboto font-medium leading-normal">
                        Total Funding: ₦{" "}
                        {sumAmounts(itemsToDisplay).toLocaleString()}{" "}
                      </p>
                      <button
                        onClick={handleExportToCsv}
                        className="bg-[#88087B] border border-[#88087B] px-2 rounded-md text-[#FFCD1E] text-center text-shadow font-roboto text-base font-medium leading-normal"
                      >
                        Export
                      </button>
                    </div>
                    <Scrollbar
                      currentPage={currentPage}
                      totalPages={Math.ceil(totalItems / itemsPerPage)}
                      itemsPerPage={itemsPerPage}
                      totalItems={totalItems}
                      onPrevPageClick={handlePrevPageClick}
                      onNextPageClick={handleNextPageClick}
                    />
                  </section>
                )}

                {itemsToDisplay?.length < 1 && (
                  <EmptyState
                    title={"No Funding History"}
                    text={"Your Funding History would be displayed here"}
                  />
                )}
              </div>
            )}
            {index === 1 && <div>Failed</div>}
            {index === 2 && <div>Accepted</div>}
            {index === 3 && <div>In Progress</div>}
            {index === 4 && <div>In Dispute</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Funding;
